/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionUser } from '../../models/subscription-user';

export interface GetUserOfSubscription$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  userUid: string;
}

export function getUserOfSubscription(http: HttpClient, rootUrl: string, params: GetUserOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionUser>> {
  const rb = new RequestBuilder(rootUrl, getUserOfSubscription.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('userUid', params.userUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionUser>;
    })
  );
}

getUserOfSubscription.PATH = '/subscriptions/{uid}/users/{userUid}';
